<template>
  <div>
    <h4 class="mb-3">Locations Status</h4>
    <div v-if="retrievingLocations" class="my-5 text-center">
      <i class="fas fa-sync-alt fa-spin fa-3x"/>
    </div>
    <div v-else-if="!locations.length" class="text-center text-muted">
      Unable to load locations.
    </div>
    <template v-else>
      <div
        v-if="upToDate.length > 0"
        class="mb-2"
      >
        <i class="fas fa-check-circle text-success fa-fw"/>
        {{ upToDate.length }} Location{{ upToDate.length === 1 ? '' : 's'}} up to date
      </div>

      <template v-if="outOfDate.length > 0">
        <div
          v-for="location in outOfDate"
          :key="location.id"
          class="mb-2"
        >
          <i class="fas fa-times-circle text-danger fa-fw"/> {{ location.name }}
          <small class="text-muted" v-if="!location.lastPing">has never contacted TCC</small>
          <small class="text-muted" v-else>
            has not contacted TCC since {{ location.lastPing.format('dddd, MMMM Do YYYY, h:mm:ss a')}}
          </small>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'LocationsStatus',
  computed: {
    ...mapGetters('menuPublish', ['locationsData']),
    ...mapState('menuPublish', ['retrievingLocations']),
    locations () {
      return Object.values(this.locationsData).map(it => ({
        id: it.id,
        name: it.name,
        lastPing: it.lastPing ? moment(it.lastPing) : null
      }))
    },
    upToDate () {
      return this.locations.filter(it => it.lastPing && it.lastPing.isAfter(moment().subtract(24, 'hours')))
    },
    outOfDate () {
      return this.locations.filter(it => !it.lastPing || it.lastPing.isSameOrBefore(moment().subtract(24, 'hours')))
    }
  }
}
</script>
